import { ReactElement, useContext } from "react"
import { ComponentState } from "../../../data/enums/ComponentState"
import { FormContext } from "../../context/contact/contact-context"
import { FormContextProps } from "../../context/contact/contact-context-props"
import { Spinner } from "../spinner/spinner"
import { ButtonProps } from "./button-props"
import * as S from './button-style'

export function Button ({ children, ...rest }: ButtonProps): ReactElement {
  const { state } = useContext<FormContextProps>(FormContext)
  return <S.Container {...rest} disabled={state === ComponentState.ERROR}>
    {state === ComponentState.SENDING ? <Spinner /> : children}
  </S.Container>
}